import { GenericTypes } from '../Core';

import {
  machine as GeoLocationMachine,
  Docs as GeoLocationDocs,
} from './GeoLocation/GeoLocation.machine';
import {
  machine as GetCommonContent,
  Docs as GetCommonContentDocs,
} from './ContentCommon/CommonContent.machine';
import {
  machine as HeadlessDeliveryMachine,
  Docs as HeadlessDeliveryDocs,
} from './HeadlessDelivery/HeadlessDelivery.machine';
import {
  machine as PartnerTokenMachine,
  Docs as PartnerTokenDocs,
} from './PartnerToken/PartnerToken.machine';
import {
  machine as UploadFileS3Machine,
  Docs as UploadFileS3Docs,
} from './UploadFileS3/UploadFileS3.machine';
import {
  machine as CountriesMachine,
  Docs as CountriesDocs,
} from './Countries/Countries.machine';
import {
  machine as ZipCodeMachine,
  Docs as ZipCodeDocs,
} from './ZipCode/ZipCode.machine';

import {
  machine as ListOfValuesMachine,
  Docs as ListOfValuesDocs,
} from './ListOfValues.machine';

import {
  machine as GetCmsContentMachine,
  Docs as GetCmsContentDocs,
} from './GetCmsContent/GetCmsContent.machine';

import {
  machine as GetCmsCobrandedCardMachine,
  Docs as GetCmsCobrandedCardDocs,
} from './GetCmsCobrandedCard/GetCmsCobrandedCard.machine';

import {
  machine as GetCmsClubSmilesTermsMachine,
  Docs as GetCmsClubSmilesTermsDocs,
} from './GetCmsClubSmilesTerms/GetCmsClubSmilesTerms.machine';

import {
  machine as CobrandedCommonQuestions,
  Docs as CobrandedCommonQuestionsDocs,
} from './GetCmsCobrandedCommonQuestions/GetCobrandedCommonQuestions.machine';

import {
  machine as CobrandedUsefulPhones,
  Docs as CobrandedUsefulPhonesDocs,
} from './GetCmsCobrandedUsefulPhones/GetCobrandedUsefulPhones.machine';

import {
  machine as ListPartnerTypeMachine,
  Docs as ListPartnerTypeDocs,
} from './ListPartnerType/ListPartnerType.machine';

import {
  machine as EmergencyExitMachine,
  Docs as EmergencyExitDocs,
} from './GetCmsEmergencyExit/GetCmsEmergencyExit.machine';

import {
  machine as GetCmsAirTransportContract,
  Docs as GetCmsAirTransportContractDocs,
} from './GetCmsAirTransportContract/GetCmsAirTransportContract.machine';

const onGeoLocation: GenericTypes = {
  machine: GeoLocationMachine,
  docs: GeoLocationDocs,
  order: 1,
};

const onHeadlessDelivery: GenericTypes = {
  machine: HeadlessDeliveryMachine,
  docs: HeadlessDeliveryDocs,
  order: 1,
};

const onPartnerToken: GenericTypes = {
  machine: PartnerTokenMachine,
  docs: PartnerTokenDocs,
  order: 1,
};

const onUploadFileS3: GenericTypes = {
  machine: UploadFileS3Machine,
  docs: UploadFileS3Docs,
  order: 1,
};

const onGetListCountry: GenericTypes = {
  machine: CountriesMachine,
  docs: CountriesDocs,
  order: 1,
};

const onGetZipCode: GenericTypes = {
  machine: ZipCodeMachine,
  docs: ZipCodeDocs,
  order: 1,
};

const onGetListOfValues: GenericTypes = {
  machine: ListOfValuesMachine,
  docs: ListOfValuesDocs,
  order: 1,
};

const onGetCmsContent: GenericTypes = {
  machine: GetCmsContentMachine,
  docs: GetCmsContentDocs,
  order: 1,
};

const onGetCmsCobrandedCard: GenericTypes = {
  machine: GetCmsCobrandedCardMachine,
  docs: GetCmsCobrandedCardDocs,
  order: 1,
};

const onListPartnerType: GenericTypes = {
  machine: ListPartnerTypeMachine,
  docs: ListPartnerTypeDocs,
  order: 1,
};

export const onGetCommonContent: GenericTypes = {
  machine: GetCommonContent,
  docs: GetCommonContentDocs,
  order: 1,
};

export const onGetCmsCobrandedCommonQuestions: GenericTypes = {
  machine: CobrandedCommonQuestions,
  docs: CobrandedCommonQuestionsDocs,
  order: 1,
};

export const onGetCmsCobrandedUsefulPhones: GenericTypes = {
  machine: CobrandedUsefulPhones,
  docs: CobrandedUsefulPhonesDocs,
  order: 1,
};

export const onGetCmsAirTransportContract: GenericTypes = {
  machine: GetCmsAirTransportContract,
  docs: GetCmsAirTransportContractDocs,
  order: 1,
};

export const onGetCmsEmergencyExit: GenericTypes = {
  machine: EmergencyExitMachine,
  docs: EmergencyExitDocs,
  order: 1,
};

export const onGetCmsClubSmilesTerms: GenericTypes = {
  machine: GetCmsClubSmilesTermsMachine,
  docs: GetCmsClubSmilesTermsDocs,
  order: 1,
};

export default {
  onGeoLocation,
  onHeadlessDelivery,
  onPartnerToken,
  onUploadFileS3,
  onGetListCountry,
  onGetZipCode,
  onGetListOfValues,
  onGetCmsContent,
  onGetCmsCobrandedCard,
  onGetCmsCobrandedCommonQuestions,
  onGetCmsCobrandedUsefulPhones,
  onGetCmsAirTransportContract,
  onListPartnerType,
  onGetCommonContent,
  onGetCmsEmergencyExit,
  onGetCmsClubSmilesTerms,
};
